var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 133,
    viewBox: "0 0 169 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116 102C144.167 102 167 79.167 167 51C167 22.833 144.167 0 116 0C87.833 0 65 22.833 65 51C65 79.167 87.833 102 116 102Z",
    fill: "url(#paint0_linear_104_13)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -20,
    y: 0.625,
    width: 208.67,
    height: 151.718
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_0_104_13_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 20,
    d: "M76.643 21C97.452 21 114.547 32.274 123.874 50.787L123.978 50.993H124.209C149.65 50.993 168.295 68.357 168.295 91.34C168.295 114.13 150.052 131.968 126.467 131.968H34.581C23.689 131.968 15.142 128.484 9.32001 122.88C3.49801 117.275 0.375 109.525 0.375 100.937C0.375 86.081 9.78399 74.366 23.745 70.387L23.993 70.316L24.016 70.059C26.469 42.09 49.459 21 76.643 21Z",
    fill: "#FFEBA3",
    fillOpacity: 0.6,
    stroke: "url(#paint1_linear_104_13)",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_104_13_clip_path",
    transform: "translate(20 -0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.643 21C97.452 21 114.547 32.274 123.874 50.787L123.978 50.993H124.209C149.65 50.993 168.295 68.357 168.295 91.34C168.295 114.13 150.052 131.968 126.467 131.968H34.581C23.689 131.968 15.142 128.484 9.32001 122.88C3.49801 117.275 0.375 109.525 0.375 100.937C0.375 86.081 9.78399 74.366 23.745 70.387L23.993 70.316L24.016 70.059C26.469 42.09 49.459 21 76.643 21Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_104_13",
    x1: 167,
    y1: 0,
    x2: 65,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBEB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BB5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_104_13",
    x1: -0.00000211969,
    y1: 20.625,
    x2: 169,
    y2: 132.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742629,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/Sunny.76bbf6af0bc40ea9b31280ceb97685b9.svg";
export { ForwardRef as ReactComponent };